import React from 'react';
import PropTypes from 'prop-types';
import ConnectedIntelligentScreening from './ConnectedIntelligentScreening';

function IntelligentScreeningRouting({ match }) {
  // TODO: Figure out which filters we want to pass in via a URL
  //const { patientId } = match.params;

  return <ConnectedIntelligentScreening />;
}

IntelligentScreeningRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default IntelligentScreeningRouting;
